import SocialStyleWrapper from "./SocialProfile.style";
import Twitter from "../../assets/images/twitter.svg";
import Discord from "../../assets/images/discord.svg";
import Telegram from "../../assets/images/telegram.svg";

const Social = () => {
  return (
    <SocialStyleWrapper>
      <div className="container">
        <div className="social-link-list">
          <a href="https://x.com/orbpad_fi" target="_blank">
            <img src={Twitter} alt="social icon" />
          </a>
          {/* <a href="#">
            <img src={Discord} alt="social icon" />
          </a> */}
          <a href="https://t.me/OrbPad_Portal" target="_blank">
            <img src={Telegram} alt="social icon" />
          </a>
        </div>
      </div>
    </SocialStyleWrapper>
  );
};

export default Social;
